// @flow

import React from 'react'
import { useSelector } from 'react-redux'

function SessionExpired () {
  const token = useSelector(state => state.account.token)
  const redirect = useSelector(state => state.account.redirect)
  const subdomain = useSelector(state => state.account.subdomain)

  const redirectUrl = subdomain
    ? `https://${subdomain}.theemployeeapp.com`
    : redirect

  return (
    (token.length === 0)
      ? <div className='modal' style={{ display: 'flex' }}>
        <div className='tokenExpiration'>
          <h1>Your session has ended</h1>
          <p>Please go <a href={redirectUrl}>back to the Web App</a> to login.</p>
        </div>
      </div>
      : ''
  )
}

export default SessionExpired
